
import React, { useState, useEffect } from 'react'
import "./PaginaCotaCapital.css"
import Loading from "../../componentes/Loading/Loading";
import { Button } from "react-bootstrap";

const PaginaCotaCapital = () => {


    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({})



    function buscarPdfCotaCapital(sintetizar) {
        setLoading(true);
        const endPoint = `/api/gerar-pdf-cota-capital?sintetizar=${sintetizar}`;
        //const endPoint = `http://localhost:8080/api/gerar-pdf-cota-capital?sintetizar=${sintetizar}`;
        fetch(endPoint, {
            method: 'get',
            headers: new Headers({
                'Accept': 'application/json',
                'Authorization': `Bearer ${getUrlParamByName("token")}`
            })
        })
            .then(resposta => resposta.json())
            .then(json => {
                setLoading(false);
                downLoadFile(json.conteudoBase64, json.nome, "openNewTab");

            })
            .catch(error => {
                setLoading(false);
                console.log(error);
                alert('Não foi possível carregar o PDF referente ao extrato de Cota Capital selecionado');
            })
    }

    function getUrlParamByName(name, url) {
        if (!url)
            url = document.URL;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    function downLoadFile(conteudoBase64, nameArq, opcao) {
        console.log("Executando Download Arquivo:" + nameArq)
        const bufferArray = base64ToArrayBuffer(conteudoBase64);
        let blob = new Blob([bufferArray], { type: 'application/pdf' });
        let url = window.URL.createObjectURL(blob);
        if (opcao == "openNewTab") {
            var newWindow = window.open(url, '_blank');
            setTimeout(function () { newWindow.document.title = nameArq; }, 3000);
        } else {
            let a = document.createElement('a');
            a.href = url;
            a.download = nameArq;
            a.click();
        }
    }

    function base64ToArrayBuffer(conteudoBase64) {
        const bString = window.atob(conteudoBase64);
        const bLength = bString.length;
        const bytes = new Uint8Array(bLength);
        for (let i = 0; i < bLength; i++) {
            bytes[i] = bString.charCodeAt(i);
        }
        return bytes;
    }


    return (
        <section >
            <div className="pagina-cota-capital">
                <div className="texto-msg">
                    <span >Selecione abaixo uma das opções para emitir o extrato de cota capital social:</span>
                </div>
                <div className="row">
                    <div className="col-md-3 col-xs-6">
                        <Button className='botao-imprimir' onClick={() => buscarPdfCotaCapital("false")}>
                            Extrato Analítico
                        </Button>
                    </div>
                    <div className="col-md-3 col-xs-6">
                        <Button className='botao-imprimir' onClick={() => buscarPdfCotaCapital("true")}>
                            Extrato Sintético
                        </Button>
                    </div>
                </div>
            </div>
            {loading && <Loading />}
        </section >
    );
}
export default PaginaCotaCapital;
